<template>
  <div v-bem @mouseleave="closeSubmenu">
    <ul v-bem:menu.firstLevel>
      <li v-for="(item, index) in menuData" :key="index" v-bem:item.firstLevel>
        <a
          v-hover-intent:250="() => openSubmenu(index)"
          v-bem:link.firstLevel="{ isActive: activeSubmenu === index }"
          :href="item.children ? '#' : item.url"
        >
          {{ item.title }}
        </a>
        <transition name="fade">
          <ul
            v-if="item.children && activeSubmenu === index"
            ref="submenu"
            v-bem:menu.secondLevel
          >
            <li
              v-for="(child, childIndex) in item.children"
              :key="childIndex"
              v-bem:item.secondLevel
            >
              <a v-bem:link.secondLevel :href="child.url">
                {{ child.title }}
              </a>
            </li>
          </ul>
        </transition>
      </li>
    </ul>
    <transition name="fade">
      <div
        v-if="!!activeSubmenuChildren.length"
        v-bem:backdrop
        :style="{ height: `${backdropHeight}px` }"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'MainMenu',
  data() {
    return {
      backdropHeight: 0,
    };
  },
  computed: {
    ...mapState('pageHeader', ['menuData', 'activeSubmenu']),
    ...mapGetters('pageHeader', ['activeSubmenuChildren']),
  },
  watch: {
    activeSubmenu() {
      // Wait until the state changes are reflected in the DOM.
      this.$nextTick(() => {
        // Since the ref is set inside a loop Vue populates an array. We know
        // with the current implementation there can't be more than one
        // element inside so it is save to pop it from the stack.
        const submenuElement = this.$refs.submenu && this.$refs.submenu.pop();

        if (submenuElement) {
          // this.setHeight(submenuElement.getBoundingClientRect().height);
          this.backdropHeight = submenuElement.getBoundingClientRect().height;
        }
      });
    },
  },
  methods: mapActions('pageHeader', ['openSubmenu', 'closeSubmenu']),
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use 'sass:map';

@include utils.vue-transition-fade;

.main-menu {
  @at-root #{&}__menu {
    padding: 0;
    margin: 0;
    list-style-type: none;
    white-space: nowrap;

    @at-root #{&}--first-level {
      position: relative;
      z-index: 2;
      display: flex;
      padding: 0;
    }

    @at-root #{&}--second-level {
      position: absolute;
      margin: 0 utils.f-rem-calc(12);
      padding: utils.f-rem-calc(12) 0;
      background-color: transparent;
    }
  }

  @at-root #{&}__item {
    @at-root #{&}--first-level {
      position: relative;
    }
  }

  @at-root #{&}__link {
    color: #{map.get(utils.$v-colors, acc-black)};
    text-decoration: none;
    font-size: utils.f-rem-calc(16);
    line-height: utils.f-rem-calc(24);
    transition: all 320ms;

    &:hover {
      color: map.get(utils.$v-colors, acc-orange);
    }

    @at-root #{&}--is-active {
      color: map.get(utils.$v-colors, acc-orange);
    }

    @at-root #{&}--first-level {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: utils.f-rem-calc(30) utils.f-rem-calc(12);
    }

    @at-root #{&}--second-level {
      display: block;
      padding: utils.f-rem-calc(5) 0;
    }
  }

  @at-root #{&}__backdrop {
    display: block;
    position: absolute;
    z-index: 1;
    right: 0;
    left: 0;
    height: 0;
    background-color: map.get(utils.$v-colors, acc-gray-020);
    transition: height 125ms, opacity 250ms;
  }
}
</style>
